var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("发布招标书")])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "bidding-container",
        staticStyle: { width: "1100px", margin: "0 auto" }
      },
      [
        _c("h1", { staticClass: "main-title" }, [_vm._v("招 标 书")]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "el-form",
          { ref: "bidDoc", attrs: { model: _vm.callBidDoc, rules: _vm.rules } },
          [
            _c(
              "div",
              { staticClass: "bidding-form-wrap" },
              [
                _c(
                  "fieldset",
                  [
                    _c(
                      "div",
                      { staticClass: "content-caption required dashed" },
                      [_c("span", {}, [_vm._v("招标标题")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "title" } },
                      [
                        _c("el-input", {
                          staticClass: "width-3x",
                          attrs: { placeholder: "为该招标单写个标题（必填）" },
                          model: {
                            value: _vm.callBidDoc.title,
                            callback: function($$v) {
                              _vm.$set(_vm.callBidDoc, "title", $$v)
                            },
                            expression: "callBidDoc.title"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("fieldset", [
                  _c("div", { staticClass: "content-caption dashed" }, [
                    _c("span", [_vm._v("招标预算")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.callBidDoc.budgetFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.callBidDoc, "budgetFlag", $$v)
                            },
                            expression: "callBidDoc.budgetFlag"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("无预算")
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("固定总额")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.callBidDoc.budgetFlag == 2
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mr20",
                              attrs: { prop: "budgetAmount" }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: { placeholder: "请输入金额" },
                                model: {
                                  value: _vm.callBidDoc.budgetAmount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.callBidDoc,
                                      "budgetAmount",
                                      $$v
                                    )
                                  },
                                  expression: "callBidDoc.budgetAmount"
                                }
                              }),
                              _vm._v("  "),
                              _c("span", [_vm._v("单位（元）")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("swb-create-call-item", {
                  ref: "swb_create_call_item",
                  attrs: { vendor: _vm.vendor, id: _vm.callbidDocId }
                }),
                _vm._v(" "),
                _c("fieldset", [
                  _c("div", { staticClass: "content-caption dashed" }, [
                    _c("span", [_vm._v("招标方式")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.callBidDoc.directed,
                            callback: function($$v) {
                              _vm.$set(_vm.callBidDoc, "directed", $$v)
                            },
                            expression: "callBidDoc.directed"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("公开招标")
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("定向招标")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.callBidDoc.directed == true
                        ? _c("span", [
                            _c(
                              "a",
                              {
                                staticClass: "ml10",
                                staticStyle: { color: "blue" },
                                on: { click: _vm.showCallbidTargetsDialog }
                              },
                              [_vm._v("[ 选择 ]")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.directedMerchantList.length > 0,
                                    expression: "directedMerchantList.length >0"
                                  }
                                ],
                                staticClass: "ml10",
                                staticStyle: { color: "blue" },
                                on: { click: _vm.clearCallbidTargets }
                              },
                              [_vm._v(" 清除所选 ")]
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.callBidDoc.directed == true
                    ? _c("div", { staticClass: "ml15 mt20" }, [
                        _vm.callBidDoc.directed == true
                          ? _c("div", { staticClass: "ml15" }, [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.directedMerchantList
                                        .pluck("name")
                                        .join("、")
                                    )
                                  )
                                ])
                              ])
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br")
                ]),
                _vm._v(" "),
                _c("fieldset", [
                  _c("div", { staticClass: "simple-form" }, [
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", { staticClass: "required" }, [
                          _vm._v("上传招标书")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c("swb-file-upload", {
                            attrs: {
                              fileGroup: "image-goods",
                              onBeforeUpload: _vm.onBeforeUpload,
                              onProgress: _vm.onProgress,
                              onDone: _vm.onUploadDone,
                              multipleFile: true
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "file-area clearfix" },
                            _vm._l(_vm.fileList, function(file, index) {
                              return _c("swb-file-item", {
                                attrs: {
                                  trackKey: index,
                                  editable: true,
                                  tag: file.tag,
                                  fileName: file.name,
                                  fileUuid: file.fileUuid,
                                  fileBrowseUrl: file.fileBrowseUrl,
                                  fileDownloadUrl: file.fileDownloaddUrl,
                                  fileMd5: file.fileMd5,
                                  deletable: true,
                                  onDelete: _vm.removeUpload,
                                  onUploaded: _vm.echoUploadedFileInfo
                                }
                              })
                            })
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("fieldset", [
                  _c(
                    "div",
                    { staticClass: "content-caption required dashed" },
                    [_c("span", [_vm._v("内容摘要")])]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "simple-form" }, [
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v("内容摘要")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-2x" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "digest" } },
                            [
                              _c("el-input", {
                                staticClass: "width-3x",
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "请输入内容摘要"
                                },
                                model: {
                                  value: _vm.callBidDoc.digest,
                                  callback: function($$v) {
                                    _vm.$set(_vm.callBidDoc, "digest", $$v)
                                  },
                                  expression: "callBidDoc.digest"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("fieldset", [
                  _c("div", { staticClass: "content-caption dashed" }, [
                    _c("span", [_vm._v("报名/投标时间")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "simple-form" }, [
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label " }, [
                        _c("label", { staticClass: "required" })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-2x" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "enrollCloseTime" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "picker-options": _vm.pickerOptions0,
                                  type: "datetime",
                                  format: "yyyy-MM-dd HH:mm",
                                  placeholder: "选择日期"
                                },
                                model: {
                                  value: _vm.callBidDoc.enrollCloseTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.callBidDoc,
                                      "enrollCloseTime",
                                      $$v
                                    )
                                  },
                                  expression: "callBidDoc.enrollCloseTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label " }, [
                        _c("label", { staticClass: "required" }, [
                          _vm._v("资格预审结束")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-2x" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "openTime" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "picker-options": _vm.pickerOptions0,
                                  type: "datetime",
                                  format: "yyyy-MM-dd HH:mm",
                                  placeholder: "选择日期"
                                },
                                model: {
                                  value: _vm.callBidDoc.openTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.callBidDoc, "openTime", $$v)
                                  },
                                  expression: "callBidDoc.openTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label " }, [
                        _c("label", { staticClass: "required" }, [
                          _vm._v("投标截止时间")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-2x" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "closeTime" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "picker-options": _vm.pickerOptions0,
                                  type: "datetime",
                                  format: "yyyy-MM-dd HH:mm",
                                  placeholder: "选择日期"
                                },
                                model: {
                                  value: _vm.callBidDoc.closeTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.callBidDoc, "closeTime", $$v)
                                  },
                                  expression: "callBidDoc.closeTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label " }, [
                        _c("label", { staticClass: "required" }, [
                          _vm._v("公布结果时间")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-2x" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "resultPublishTime" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "picker-options": _vm.pickerOptions0,
                                  type: "datetime",
                                  format: "yyyy-MM-dd HH:mm",
                                  placeholder: "选择日期"
                                },
                                model: {
                                  value: _vm.callBidDoc.resultPublishTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.callBidDoc,
                                      "resultPublishTime",
                                      $$v
                                    )
                                  },
                                  expression: "callBidDoc.resultPublishTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("fieldset", [
                  _c("div", { staticClass: "content-caption dashed" }, [
                    _c("span", [_vm._v("联系方式")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "simple-form" }, [
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label " }, [
                        _c("label", { staticClass: "required" }, [
                          _vm._v("联系人")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-2x" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "contactName" } },
                            [
                              _c("el-input", {
                                staticClass: "width-1x",
                                attrs: { placeholder: "请输入内容" },
                                model: {
                                  value: _vm.callBidDoc.contactName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.callBidDoc, "contactName", $$v)
                                  },
                                  expression: "callBidDoc.contactName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label " }, [
                        _c("label", { staticClass: "required" }, [
                          _vm._v("联系方式")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-2x" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "contactTel" } },
                            [
                              _c("el-input", {
                                staticClass: "width-1x",
                                attrs: { placeholder: "请输入联系方式" },
                                model: {
                                  value: _vm.callBidDoc.contactTel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.callBidDoc, "contactTel", $$v)
                                  },
                                  expression: "callBidDoc.contactTel"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v("电子邮箱")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-2x" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "contactEmail" } },
                            [
                              _c("el-input", {
                                staticClass: "width-1x",
                                attrs: { placeholder: "请输入联系方式" },
                                model: {
                                  value: _vm.callBidDoc.contactEmail,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.callBidDoc,
                                      "contactEmail",
                                      $$v
                                    )
                                  },
                                  expression: "callBidDoc.contactEmail"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("fieldset", [
                  _c("div", { staticClass: "content-caption dashed" }, [
                    _c("span", [_vm._v("招标要求")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "simple-form" }, [
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v("报名费")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.callBidDoc.enrollFree,
                                callback: function($$v) {
                                  _vm.$set(_vm.callBidDoc, "enrollFree", $$v)
                                },
                                expression: "callBidDoc.enrollFree"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("免费")
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("收费")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.callBidDoc.enrollFree
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "enrollFee" } },
                                    [
                                      _c("el-input", {
                                        staticClass: "width-1-5x",
                                        attrs: { placeholder: "请输入金额" },
                                        model: {
                                          value: _vm.callBidDoc.enrollFee,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.callBidDoc,
                                              "enrollFee",
                                              $$v
                                            )
                                          },
                                          expression: "callBidDoc.enrollFee"
                                        }
                                      }),
                                      _vm._v("  "),
                                      _c("span", [_vm._v("单位(元)")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label " }, [
                        _c("label", { staticClass: "required" }, [
                          _vm._v("保证金")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "reqDeposit" } },
                            [
                              _c("el-input", {
                                staticClass: "width-1x",
                                attrs: { placeholder: "请输入金额" },
                                model: {
                                  value: _vm.callBidDoc.reqDeposit,
                                  callback: function($$v) {
                                    _vm.$set(_vm.callBidDoc, "reqDeposit", $$v)
                                  },
                                  expression: "callBidDoc.reqDeposit"
                                }
                              }),
                              _vm._v("  "),
                              _c("span", [_vm._v("单位(元)")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v("资质要求")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _c("span", [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "blue" },
                              on: { click: _vm.selectQualiTypes }
                            },
                            [_vm._v("[ 选择 ]")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.callBidReqQualiList.length > 0,
                                  expression: "callBidReqQualiList.length >0"
                                }
                              ],
                              staticClass: "ml10",
                              staticStyle: { color: "blue" },
                              on: { click: _vm.clearCallBidReqQualiList }
                            },
                            [_vm._v(" 清除所选 ")]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.callBidReqQualiList.length > 0
                          ? _c("table", { staticClass: "custom-tbl" }, [
                              _c("thead", { staticClass: "head" }, [
                                _c("tr", { staticClass: "row" }, [
                                  _c("th", { attrs: { width: "" } }, [
                                    _vm._v("序号")
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { width: "" } }, [
                                    _vm._v("组号")
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { width: "200px" } }, [
                                    _vm._v("资质名称")
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { width: "" } }, [
                                    _vm._v("资质类型")
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { width: "" } }, [
                                    _vm._v("是否强制")
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { width: "" } }, [
                                    _vm._v("操作")
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                { staticClass: "body" },
                                _vm._l(_vm.callBidReqQualiList, function(
                                  callBidReqQuali,
                                  index
                                ) {
                                  return _c("tr", { staticClass: "row" }, [
                                    _c("td", [
                                      _c("div", { staticClass: "table-addr" }, [
                                        _c("span", [_vm._v(_vm._s(index + 1))])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("div", { staticClass: "table-addr" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.number",
                                              value: callBidReqQuali.groupNo,
                                              expression:
                                                "callBidReqQuali.groupNo",
                                              modifiers: { number: true }
                                            }
                                          ],
                                          staticStyle: { width: "100%" },
                                          attrs: { type: "text" },
                                          domProps: {
                                            value: callBidReqQuali.groupNo
                                          },
                                          on: {
                                            blur: [
                                              function($event) {
                                                _vm.sortblur(callBidReqQuali)
                                              },
                                              function($event) {
                                                _vm.$forceUpdate()
                                              }
                                            ],
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                callBidReqQuali,
                                                "groupNo",
                                                _vm._n($event.target.value)
                                              )
                                            }
                                          }
                                        })
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("div", { staticClass: "table-addr" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              callBidReqQuali.qualiTypeName
                                            )
                                          )
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("div", { staticClass: "table-addr" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.qualiKindList[
                                                callBidReqQuali.qualiKind
                                              ].text
                                            )
                                          )
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "table-addr",
                                          on: {
                                            change: function($event) {
                                              _vm.changeRadio(callBidReqQuali)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value:
                                                  callBidReqQuali.mandatory,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    callBidReqQuali,
                                                    "mandatory",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "callBidReqQuali.mandatory"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: false } },
                                                [_vm._v("否")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: true } },
                                                [_vm._v("是")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("div", { staticClass: "table-addr" }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "swb-btn-link",
                                            on: {
                                              click: function($event) {
                                                _vm.delCallBidReqQuali(
                                                  callBidReqQuali
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("移除")]
                                        )
                                      ])
                                    ])
                                  ])
                                })
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v("注册资金(含)")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c("el-input", {
                            staticClass: "width-1x",
                            attrs: { placeholder: "请输入内容" },
                            model: {
                              value: _vm.callBidDoc.reqRegCapital,
                              callback: function($$v) {
                                _vm.$set(_vm.callBidDoc, "reqRegCapital", $$v)
                              },
                              expression: "callBidDoc.reqRegCapital"
                            }
                          }),
                          _vm._v("  "),
                          _c("span", [_vm._v("(万元)以上")])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v("成立时间")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-1-5x" },
                        [
                          _c("el-date-picker", {
                            attrs: { type: "date", placeholder: "选择日期" },
                            model: {
                              value: _vm.callBidDoc.foundDate,
                              callback: function($$v) {
                                _vm.$set(_vm.callBidDoc, "foundDate", $$v)
                              },
                              expression: "callBidDoc.foundDate"
                            }
                          }),
                          _vm._v("  "),
                          _c("span", [_vm._v("之前")])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v("人员资质要求")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-value" }, [
                        _c(
                          "a",
                          {
                            staticStyle: { color: "blue" },
                            on: { click: _vm.selectStaffQualiTypes }
                          },
                          [_vm._v("[ 直接选择 ]")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.staffQualiTypes.length > 0,
                                expression: "staffQualiTypes.length >0"
                              }
                            ],
                            staticClass: "ml10",
                            staticStyle: { color: "blue" },
                            on: { click: _vm.clearStaffQualiTypes }
                          },
                          [_vm._v(" 清除所选 ")]
                        ),
                        _vm._v(" "),
                        _vm.staffQualiTypes.length > 0
                          ? _c("table", { staticClass: "custom-tbl" }, [
                              _c("thead", { staticClass: "head" }, [
                                _c("tr", { staticClass: "row" }, [
                                  _c("th", { attrs: { width: "" } }, [
                                    _vm._v("资质类型")
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { width: "" } }, [
                                    _vm._v("类型名称")
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { width: "200px" } }, [
                                    _vm._v("类型等级")
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { width: "" } }, [
                                    _vm._v("要求数量")
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { width: "" } }, [
                                    _vm._v("是否强制")
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { width: "" } }, [
                                    _vm._v("操作")
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                { staticClass: "body" },
                                _vm._l(_vm.staffQualiTypes, function(
                                  staffQualiType,
                                  index
                                ) {
                                  return _c("tr", { staticClass: "row" }, [
                                    _c("td", [
                                      _c("div", { staticClass: "table-addr" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(staffQualiType.name))
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("div", { staticClass: "table-addr" }, [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(staffQualiType.qualiName)
                                          )
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("div", { staticClass: "table-addr" }, [
                                        staffQualiType.qualiLevel == 1
                                          ? _c("span", [_vm._v("一级")])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        staffQualiType.qualiLevel == 2
                                          ? _c("span", [_vm._v("二级")])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        staffQualiType.qualiLevel == 3
                                          ? _c("span", [_vm._v("三级")])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        staffQualiType.qualiLevel == 4
                                          ? _c("span", [_vm._v("四级")])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        staffQualiType.qualiLevel == 5
                                          ? _c("span", [_vm._v("五级")])
                                          : _vm._e()
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("div", { staticClass: "table-addr" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.number",
                                              value: staffQualiType.quantity,
                                              expression:
                                                "staffQualiType.quantity",
                                              modifiers: { number: true }
                                            }
                                          ],
                                          staticStyle: { width: "100%" },
                                          attrs: { type: "text" },
                                          domProps: {
                                            value: staffQualiType.quantity
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                staffQualiType,
                                                "quantity",
                                                _vm._n($event.target.value)
                                              )
                                            },
                                            blur: function($event) {
                                              _vm.$forceUpdate()
                                            }
                                          }
                                        })
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "table-addr",
                                          on: {
                                            change: function($event) {
                                              _vm.changeStaffQualiRadio(
                                                staffQualiType
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value: staffQualiType.mandatory,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    staffQualiType,
                                                    "mandatory",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "staffQualiType.mandatory"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: false } },
                                                [_vm._v("否")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: true } },
                                                [_vm._v("是")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("div", { staticClass: "table-addr" }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "swb-btn-link",
                                            on: {
                                              click: function($event) {
                                                _vm.delStaffQualiType(
                                                  staffQualiType
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("移除")]
                                        )
                                      ])
                                    ])
                                  ])
                                })
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "fieldset",
                  [
                    _c("div", { staticClass: "content-caption dashed" }, [
                      _c("span", [_vm._v("商务条款")])
                    ]),
                    _vm._v(" "),
                    _c("swb-create-trade-rule", {
                      ref: "swb_create_trade_rule",
                      attrs: {
                        comparedTradeRuleList: _vm.comparedTradeRuleList,
                        forBid: true,
                        forGoods: true,
                        forServc: true,
                        type: _vm.type
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-toolbar" }, [
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small swb-btn-primary",
              on: {
                click: function($event) {
                  _vm.goBack()
                }
              }
            },
            [_vm._v("返回")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small swb-btn-primary",
              on: {
                click: function($event) {
                  _vm.goBack()
                }
              }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small",
              on: {
                click: function($event) {
                  _vm.saveCallBidDoc()
                }
              }
            },
            [_vm._v("保存")]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bidding-intro" }, [
      _c(
        "div",
        {
          staticClass: "content-caption dashed font18",
          staticStyle: { "background-color": "#fff" }
        },
        [
          _c("span", [
            _c("span", { staticClass: "color-laber" }),
            _vm._v("招标流程简介")
          ])
        ]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "intro-text" }, [
        _vm._v(
          "商维宝招投标采购，招标人可以公开招投标，也可以邀请招投标。公开招标方式下报名的供应商以及被邀标方式下被邀请的的供应商均需要经过报名流程并且通过采购商的资质审核后，才可以正式参与投标、提交投标文件。 "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bidding-proc" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5e03a18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5e03a18","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/callbid/CallBidDocCreate.vue
// module id = 3346
// module chunks = 0